import * as React from 'react';
import FieldBase from './FieldBase';
import FieldTypes from './enums/FieldTypes';
import { IDateFieldProperties } from './DateField';
import classNames from 'classnames';

const FullDateRegEx = /^\d{4}-\d{2}-\d{2}.*$/;

export default class FullDateField extends React.PureComponent<IDateFieldProperties> {
  constructor(props: IDateFieldProperties) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  onChange(event: React.FormEvent<HTMLInputElement>) {
    event.preventDefault();

    if (this.props.onChange !== undefined)
    {
      this.props.onChange({
        id: event.currentTarget.id,
        name: event.currentTarget.name,
        value: event.currentTarget.value
      });
    }
  }

  componentDidUpdate(prevProps: IDateFieldProperties) {
    if (prevProps.value !== this.props.value || prevProps.max !== this.props.max) {
      //Trigger re-validate      
      let [ valid, message ] = this.validate();
      if (this.props.onValidate !== undefined) {        
        this.props.onValidate({
          name: this.props.id,
          result: valid,
          message: message
        });
      }
    }
  }

  validate() : [valid: boolean, message?: string] {
    const value = this.parseDate(this.props.value);
    if (this.props.required && (value === undefined || value.trim().length === 0)) {
      return [false, `${this.props.label} is required`];
    }

    if (value !== undefined && value.trim().length > 0) {
      if (!FullDateRegEx.test(value)) {
        return [false, `${this.props.label} must be YYYY-MM-DD`];
      }

      var thisDate = new Date(value);
      const max = this.parseDate(this.props.max);
      if (max !== undefined && FullDateRegEx.test(max)) {
        var maxDate = new Date(max);
        if (!isNaN(maxDate.getTime()) && thisDate > maxDate) {
          return [false, this.props.maxErrorMessage || `Must be before ${this.props.max}`];
        }
      }
    }
    return [ true, undefined ];
  }

  parseDate(value?: string) {
    if (value !== undefined && value.indexOf('T') >= 0) {
      return value.split('T')[0];
    }
    return value;
  }

  render() {   
    let inputClasses = classNames({
      "hcs-text__input": true,
      "w-full": true,
      "input-validation-error": this.props.valid === false
    });    
    
    let value = this.parseDate(this.props.value);

    return <FieldBase key={this.props.id + "_field"} {...this.props} type={FieldTypes.TEXT}>
      <input 
        key={this.props.id + "_date"} 
        type="date" 
        className={inputClasses}
        id={this.props.id} 
        name={this.props.id} 
        value={value || ''}
        onChange={this.onChange}
        maxLength={200}
        disabled={this.props.disabled}
        required={this.props.required} />
        { this.props.valid === false && <span className="hcs-label-text__error-msg">{this.props.message}</span>}
    </FieldBase>;
  }
}